import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

import styles from './HowItWorks.module.css';

const HowItWorks = ({ sections, className }) => (
  <div className={classNames(styles.container, className)}>
    {_.map(sections, (section, index) => (
      <div className={styles.section} key={index}>
        <i className={section.icon} />
        <div className={styles.text}>
          <h4>{section.title}</h4>
          <div
            className={styles.copy}
            dangerouslySetInnerHTML={{ __html: section.copy }}
          />
        </div>
      </div>
    ))}
  </div>
);

HowItWorks.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      icon: PropTypes.string,
      copy: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
};

HowItWorks.defaultProps = {
  className: null,
};

export default HowItWorks;
